/** Blood-glucose unit options (cosmetic, not persisted). */
export var GLUCOSE_UNIT_OPTIONS = [{
  value: "mg/dL",
  label: "mg/dL"
}, {
  value: "mmol/L",
  label: "mmol/L"
}];

/** Pack-year multipliers per tobacco type for the smoking calculator. */
export var TOBACCO_MULTIPLIERS = {
  Cigarettes: 1,
  "Pipe Smoker": 2.5,
  "Cigars - Café Crème": 1.5,
  "Cigars - Hamlet": 2.5,
  "Cigars - Havana": 4,
  "Roll Ups": 50
};

/** Tobacco type options for the smoking calculator. */
export var TOBACCO_OPTIONS = Object.keys(TOBACCO_MULTIPLIERS).map(function (type) {
  return {
    value: type,
    label: type
  };
});

/** Maximum NIHSS score. */
export var NIHSS_MAX_SCORE = 42;